export const modelsEn = {
  title: 'Carus Flexible Finance and Operation Model',
  list: [
    {
      icon: 'list',
      title: 'Pay As Irvine See Result ( PSR )',
      contents: [
        'Let us build a few pilot projects for Irvine at Carus cost.',
        'Carus gets paid for electricity saving.',
        'Irvine have option to buy anytime you want.',
      ],
    },
    {
      icon: 'lightning',
      title: 'Joint Venture to reduce Irvine city electricity cost',
      contents: ['Carus provide Green Energy Solution.', 'Irvine provide space and support.'],
    },
    {
      icon: 'analysis',
      title: 'Lease & Sell to save initial investment in project development for city',
      contents: [
        'Carus raises funds to complete project development.',
        'The City lease system with the option to purchase the project at a suitable time.',
      ],
    },
    {
      icon: 'service',
      title: 'Financial Support',
      contents: [
        'Collaboration with banks and financial institutions provides project loan access, easing upfront financial constraints.',
      ],
    },
  ],
}
